import { InfoCircleOutlined } from '@ant-design/icons';
import { Col, Popover, Radio, Row, Space, Spin, Typography } from 'antd';
import React, { useContext } from 'react';
import EmpresaContext from '../context/empresa-context';

const { Text } = Typography;

const SelectProductos = ({
  setSelectedProducto,
  selectedProducto,
  tipoCotizacion,
  detalleProductoList
}) => {
  const { productos } = useContext(EmpresaContext);

  const getContentProducto = (producto) => {
    const detalleProducto = detalleProductoList.find(
      (item) => item.idProducto === producto.id
    );
    let contentToReturn;
    if (detalleProducto) {
      contentToReturn = (
        <>
          <Text>{detalleProducto.descripcion}</Text>
          {detalleProducto.link && (
            <a
              href={detalleProducto.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {' '}
              {detalleProducto.linkTitulo || detalleProducto.link}
            </a>
          )}
        </>
      );
    }
    return contentToReturn;
  };
  return (
    <Spin spinning={!productos || productos.length === 0}>
      <Row
        gutter={[16, 0]}
        justify="center"
        style={{ textAlign: 'start', paddingTop: 20 }}
      >
        <Col>
          <Radio.Group
            value={selectedProducto}
            onChange={(e) => {
              setSelectedProducto(e.target.value);
            }}
          >
            <Space direction="vertical">
              {(productos || []).map((producto) => (
                <>
                  <Radio
                    key={producto.codigo}
                    value={producto.codigo}
                    disabled={
                      tipoCotizacion === 'masiva' &&
                      producto.codigo !== 3 &&
                      producto.codigo !== 1 &&
                      producto.codigo !== 4 &&
                      producto.codigo !== 5 &&
                      producto.codigo !== 2
                    }
                  >
                    {producto.descripcion}{' '}
                    {detalleProductoList &&
                      detalleProductoList.length > 0 &&
                      getContentProducto(producto) && (
                        <Popover
                          content={getContentProducto(producto)}
                          overlayStyle={{ width: '300px' }}
                        >
                          <InfoCircleOutlined
                            style={{
                              color: 'rgba(0,0,0,.45)'
                            }}
                          />
                        </Popover>
                      )}
                  </Radio>
                </>
              ))}
            </Space>
          </Radio.Group>
        </Col>
      </Row>
    </Spin>
  );
};

export default SelectProductos;
